interface ICallStatusProps {
  width?: number;
  height?: number;
}
const GreenCheckIcon = (props: ICallStatusProps) => {
  const { width = 18, height = 18 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#00BA34" stroke="#00BA34" />
      <mask
        id="mask0_1_2973"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="16"
      >
        <rect x="1.5" y="1.5" width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_2973)">
        <path
          d="M7.66809 12.0471L5.02734 9.39135L5.80884 8.60985L7.66809 10.4541L12.1838 5.9541L12.9653 6.7506L7.66809 12.0471Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default GreenCheckIcon;
